// extracted by mini-css-extract-plugin
export var leftAlign = "_2i-2";
export var popper = "_2i-0";
export var subtitle = "_2i-1";